<template>
  <div>
    <table class="table">
      <thead>
      <tr>
        <th>币种</th>
        <th>Processor</th>
        <th>Pending高度 / Conirmed高度</th>
        <th>区块最大高度</th>
        <th>充值钱包编号</th>
        <th>扫块状态状态</th>
        <th>报错消息</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="coin in processorList">
        <tr v-for="(processor, index) in coin.pendingProcessorList" :key="`${coin.coinType}-pending-${index}`">
          <td :rowspan="coin.pendingProcessorList.length + coin.confirmedProcessorList.length" v-if="index === 0">
            {{ coin.coinType }}
          </td>
          <td>{{ processor.processor }} ( Pending Processor )</td>
          <td>
            <a @click="handlePendingHeightChange(coin.coinType, processor.processor)">
              {{ processor.processedHeight }} <i class="el-icon-edit"></i>
            </a>
          </td>
          <td :rowspan="coin.pendingProcessorList.length + coin.confirmedProcessorList.length" v-if="index === 0">
            {{ coin.networkBestHeight }}
          </td>
          <td :rowspan="coin.pendingProcessorList.length + coin.confirmedProcessorList.length" v-if="index === 0">
            {{ coin.depositWalletId }}
          </td>
          <td :rowspan="coin.pendingProcessorList.length + coin.confirmedProcessorList.length" v-if="index === 0">
            <i v-if="coin.state === true" class="el-icon-success"></i>
            <i v-if="coin.state === false" class="el-icon-error"></i>
          </td>
          <td :rowspan="coin.pendingProcessorList.length + coin.confirmedProcessorList.length" v-if="index === 0">
            {{ coin.msg }}
          </td>
        </tr>
        <tr v-for="(processor, index) in coin.confirmedProcessorList" :key="`${coin.coinType}-confirmed-${index}`">
          <td>{{ processor.processor }} ( Confirmed Processor )</td>
          <td>
            <a @click="handleConirmedHeightChange(coin.coinType, processor.processor)">
              {{ processor.processedHeight }} <i class="el-icon-edit"></i>
            </a>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
  name: 'ProcessorList',
  computed: {
    ...mapState('processorConfigSetting', ['processorList'])
  },
  methods: {
    ...mapActions('processorConfigSetting', [
      'updatePendingHeight',
      'updateConfimedHeight'
    ]),
    handlePendingHeightChange(coinType, processorId) {
      this.$prompt('请输入height', '提示', {
        inputValidator: value => {
          return !value || !value.trim() ? '请输入height' : true;
        }
      }).then(({value}) => {
        this.updatePendingHeight({coinType, processorId, height: value}).then(
            () => {
              this.$message.success('操作成功！');
              this.$emit('refresh');
            }
        );
      });
    },
    handleConirmedHeightChange(coinType, processorId) {
      this.$prompt('请输入height', '提示', {
        inputValidator: value => {
          return !value || !value.trim() ? '请输入height' : true;
        }
      }).then(({value}) => {
        this.updateConfimedHeight({coinType, processorId, height: value}).then(
            () => {
              this.$message.success('操作成功！');
              this.$emit('refresh');
            }
        );
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '~styles/variables.less';

.table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 12px 10px;
    text-align: left;
    font-weight: normal;
    font-size: 14px;
    color: @color-text-regular;
    border-bottom: 1px solid @table-border-color;
  }

  tbody {
    tr {
      td[rowspan]:first-child {
        border-right: 1px solid @table-border-color;
      }

      td[rowspan]:last-child {
        border-left: 1px solid @table-border-color;
      }
    }
  }
}
</style>
